<template>
  <v-dialog v-model="sendProgressVisible" width="1300px" class="mx-0 mb-0 mt-0 pa-0">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card class="ma-0 px-0 pt-0 pb-0">
      <!-- <v-container grid-list-md class="mx-0 px-0 pb-0 pt-0 add-product-container " style="overflow-x:hidden"> -->
        <v-row wrap no-gutters class="my-0 py-0" style="border-bottom:1px dotted #ccc;" >
          
            <v-progress-linear height="25" color="orange" :value="percentageReady">
              <span class="pt-1" style="font-weight:600;font-size:13px;">Lähetysten status: {{ numberSent }} / {{totalForSend}}</span>
            </v-progress-linear>
          
        </v-row>
        <v-row class="mt-5 pr-2" no-gutters style="font-size:12px;border-bottom:1px dotted #ccc;font-weight:600;width:100%;" >
          <v-col cols="6" class="px-0 py-0">
            <v-row no-gutters wrap class="px-0 mx-0">
              <v-col cols="1" class="py-1 pl-2">
                <span class="pl-2" >
                  <input style="vertical-align: middle;" type="checkbox" :checked="allSelected" @click="toggleSelectAll()"/> 
                  <!-- <v-icon v-if="allSelected" @click="updateBatchSelectionForItem(order.id)" style="padding-right:1px;" color="green" size="12" dark>fas fa-check-square</v-icon>
                  <v-icon v-else @click="updateBatchSelectionForItem(order.id)" style="padding-right:1px;" color="#666" size="12" dark>far fa-square</v-icon> -->
                </span>
              </v-col>
              <v-col cols="3" class="py-1 pl-2">Viesti</v-col>
              <v-col cols="2" class="py-1 pl-2">Viim. lähetys</v-col>
              <v-col cols="1" class="py-1 pl-2">Päiviä</v-col>
              <v-col cols="5" class="py-1 pl-2">Yritys</v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="px-0 py-0">
            <v-row no-gutters wrap class="px-0 mx-0">
              <v-col cols="5" class="py-1 pl-2">Tuotteet</v-col>
              <v-col cols="4" class="py-1 pl-2">Kenelle</v-col>
              <v-col cols="3" class="py-1 pl-2 text-center">Status</v-col>
            </v-row>
          </v-col>
        </v-row>
        <div style="max-height:700px;overflow-y:scroll;width:100%;" class="orange-scrollbar">
          <v-row wrap no-gutters class="mb-0 mt-0" v-for="(s) in sendsSorted" :key="s.id+'_auto_sends'" :style="getStyleForSend(s)" style="width:100%;">
            <v-col cols="6" class="px-0 py-0">
              <v-row no-gutters wrap class="px-0 mx-0" >
                <v-col cols="1" class="pl-4" style="max-width:100px;padding-top:2px;">
                  <input v-if="typeOfSendBatchSend " :disabled="!s.contactFound" style="vertical-align: middle;" type="checkbox" :checked="sendsNotSelected.includes(s.id) ? false: true" @click="sendsNotSelected.includes(s.id) ? sendsNotSelected = sendsNotSelected.filter(sId => sId !== s.id) : sendsNotSelected.push(s.id)"/> 
                </v-col>
                <v-col cols="3" class="pl-2" style="padding-top:2px !important;padding-bottom:2px !important;">
                  {{settings.typesOfEmailSends[typeOfSendBatchSend] ? settings.typesOfEmailSends[typeOfSendBatchSend].fi : typeOfSendBatchSend}}
                </v-col>
                <v-col cols="2" class="pl-2" style="padding-top:2px !important;padding-bottom:2px !important;">{{s.lastSend}}</v-col>
                <v-col cols="1" class="pl-2" style="padding-top:2px !important;padding-bottom:2px !important;">{{s.daysSinceLastSend}}</v-col>
                <v-col cols="5" class="pl-2" style="padding-top:2px !important;padding-bottom:2px !important;">
                  <div><span @click="copyToClipboard(s.companyName)">{{s.companyName}}</span> <b>Netvisor: </b><span @click="copyToClipboard(s.netvisorId)">{{s.netvisorId}}</span></div>
                  
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="px-0 py-0">
              <v-row no-gutters wrap class="px-0 mx-0">
                <v-col cols="5" class="pl-2" style="padding-top:2px !important;padding-bottom:2px !important;">
                  <div v-for="(op,i) in s.opFilter" :key="op.opId+i">
                    
                    <div>
                      <input v-if="typesOfSendWithProductSelection.includes(typeOfSendBatchSend)" :disabled="!s.contactFound" style="vertical-align: middle;" type="checkbox" :checked="opIdsNotSelected.includes(op.opId) ? false: true" @click="opIdsNotSelected.includes(op.opId) ? opIdsNotSelected = opIdsNotSelected.filter(opId => opId !== op.opId) : opIdsNotSelected.push(op.opId)"/> 
                      {{op.productName}}
                    </div>
                    <div v-if="op.printFormat"><b>Merkkaus </b>{{settings.printFormatsObject[op.printFormat].fi}}</div>
                  </div>
                  <!-- <div v-if="s.printFormats"><b>Merkkaus </b>{{s.printFormats.map(pf => settings.printFormatsObject[pf].fi).join()}}</div> -->
                </v-col>
                <v-col cols="4" class="pl-2" style="padding-top:2px !important;padding-bottom:2px !important;">
                  <div v-if="(s.typeOfSend === 'draft_reminder_wholesale' || s.typeOfSend === 'order_created_reminder_wholesale') && s.partnerType">{{s.partnerType}} - {{s.partnerName}}</div>
                  <div v-if="s.contactFound">
                    <div style="font-weight:600" @click="copyToClipboard(s.toEmail)">{{s.toEmail}}</div>
                  </div>
                  <div v-else>
                    {{s.contactNotFoundMessage}}
                  </div>
                </v-col>
                <v-col cols="3" class="text-center pl-2" style="padding-top:2px !important;padding-bottom:2px !important;">
                  <!-- {{sendsStatus[s.orderId]}} -->
                  <div v-if="sendsStatus[s.id] && sendsStatus[s.id].status == 1">
                    <i class="far fa-check-circle" style="color:green"></i>
                    <div>{{sendsStatus[s.id].message}}</div>
                  </div>
                  <div v-else-if="sendsStatus[s.id] && sendsStatus[s.id].status === 2">
                    <div><i  class="far fa-times-circle" style="color:red"></i></div>
                    <div>{{sendsStatus[s.id].message}}</div>
                  </div>
                  <div v-else-if="sendsStatus[s.id] && sendsStatus[s.id].status === 3">
                    <v-progress-circular
                      indeterminate
                      :size="16"
                      :width="3"
                      color="amber"
                    ></v-progress-circular>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      <!-- </v-container> -->
      <v-card-actions class="pt-2">
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-0 mr-1" outlined small @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-0 mr-1" outlined small @click="send">Lähetä</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
    props:['batchSendDetails','typeOfSendBatchSend'],
    data: () => ({
      allSelected:true,
      typesOfSendWithProductSelection:['order_created_reminder_wholesale'],
      sendsNotSelected:[],
      opIdsNotSelected:[],
      sendsStatus:{},
      numberSent:0,
      percentageReady:0,
    }),
    created(){
    },
    watch: {

      sendProgressVisible: {
        handler(val){
          console.log(val)
          if(val) {
            this.numberSent = 0
            this.percentageReady = 0
            this.sendsStatus = {}
            this.sendsNotSelected = []
            this.opIdsNotSelected = []
            this.batchSendDetails.forEach(s => {
              if(!s.contactFound && !this.sendsNotSelected.includes(s.id)) {
                this.sendsNotSelected.push(s.id)
                console.log("HEHREHREHREHREH")
                console.log(...s.opFilter)
                s.opFilter.forEach(op => {
                  this.opIdsNotSelected.push(op.opId)
                })
                
              }
            })
          }
        }
      },
      sendsNotSelected:{
        handler(val){
          //console.log(val)
        }
      }
    },
    mounted() {
      
    },
    computed: {
      sendsSorted(){
        var sorted = []
        var notSendSorted = []
        // DISABLED
        this.batchSendDetails.forEach(s => {
          if(!s.contactFound) sorted.push(s)
        })
        // FAILED SENDS
        this.batchSendDetails.forEach(s => {
          if(s.contactFound && this.sendsStatus[s.id] !== undefined && this.sendsStatus[s.id].status === 2) sorted.push(s)
        })
        // SUCCESS SENDS
        this.batchSendDetails.forEach(s => {
          if(s.contactFound && this.sendsStatus[s.id] !== undefined && this.sendsStatus[s.id].status === 1) sorted.push(s)
        })
        // IN PROGRESS
        this.batchSendDetails.forEach(s => {
          if(s.contactFound && this.sendsStatus[s.id] !== undefined && this.sendsStatus[s.id].status === 3) sorted.push(s)
        })
        // NOT SENT
        this.batchSendDetails.forEach(s => {
          if(s.contactFound && this.sendsStatus[s.id] === undefined) notSendSorted.push(s)
        })
        notSendSorted = notSendSorted.sort((a,b) => {
          var aDays = a.daysSinceLastSend ? a.daysSinceLastSend : 0
          var bDays = b.daysSinceLastSend ? b.daysSinceLastSend : 0
          return bDays-aDays
        })
        
        return [...sorted,...notSendSorted]
      },
      totalForSend(){
        return this.batchSendDetails.length - this.sendsNotSelected.length
      },
      ...mapFields({
        settings:"settings",
        staff:"staff.staff",
        user:'user',
        orders:'order.orders',
        contacts:'contact.contacts',
        companies:'company.companies',
        orderedProducts:'orderedProduct.orderedProducts',
        sendProgressVisible:"modals.orders.sendProgress.visible",
      })
    },
    methods: {
      toggleSelectAll(){
        var current = this.allSelected
        var newSelection = !current
        console.log("HEELLO")
        console.log(newSelection)
        if(newSelection) this.sendsNotSelected = []
        this.batchSendDetails.forEach(s => {
          if(newSelection) {
            console.log("HERE")
            if(!s.contactFound && !this.sendsNotSelected.includes(s.id)) this.sendsNotSelected.push(s.id)
          }
          else {
            if(!this.sendsNotSelected.includes(s.id)) this.sendsNotSelected.push(s.id)
          }
          
        })
        this.allSelected = newSelection
      },
      timer(ms) { return new Promise(res => setTimeout(res, ms)); },
      getStyleForSend(s){
        if(!s.contactFound) return 'font-size:12px;border-bottom:1px dotted #ccc;background:#eee;'
        if(s.contactFound && this.sendsStatus[s.id] !== undefined && this.sendsStatus[s.id].status === 1) return 'font-size:12px;border-bottom:1px dotted #ccc;background:#DCEDC8;'
        if(s.contactFound && this.sendsStatus[s.id] !== undefined && this.sendsStatus[s.id].status === 2) return 'font-size:12px;border-bottom:1px dotted #ccc;background:#FFCDD2;'
        if(s.contactFound && this.sendsStatus[s.id] !== undefined && this.sendsStatus[s.id].status === 3) return 'font-size:12px;border-bottom:1px dotted #ccc;'
        else return 'font-size:12px;border-bottom:1px dotted #ccc;'
      },
      async send(){
        this.numberSent = 0
        this.percentageReady = 0
        this.sendsStatus = {}
        var customer = false
        var fromEmail = ''
        for(const s of this.batchSendDetails){
          if(!s.contactFound) continue
          if(this.sendsNotSelected.includes(s.id)) continue
          var sendsStatus = JSON.parse(JSON.stringify(this.sendsStatus))
          sendsStatus[s.id] = {status:3}
          this.sendsStatus = sendsStatus
          var status = false
          var message = ''
          
          try{
            /* console.log({
              toEmail:s.toEmail,
              fromEmail:s.fromEmail,
              customer:s.customer,
              opIds:s.opIds,
              companyId:s.companyId,
              contactId:s.contactId,
              orderId:s.orderId,
              typeOfSend:s.typeOfSend
            }) */
            var opFilter = s.opFilter ? JSON.parse(JSON.stringify(s.opFilter)) : []
            opFilter = opFilter.filter(op => {
              return !this.opIdsNotSelected.includes(op.opId)
            })
            console.log(opFilter)
            
            var toEmail = s.toEmail
            var res = await this.$store.dispatch('sendMessageServerSide', {
                toEmail,
                fromEmail:s.fromEmail,
                customer:s.customer,
                opIds:s.opIds,
                opFilter,
                companyId:s.companyId,
                contactId:s.contactId,
                orderId:s.orderId,
                typeOfSend:s.typeOfSend,
                dontShowSending:true
            })
            message = res.data.message
            status = 1
          }
          catch(e){
            console.log(e)
            status = 2
            message = e
          }
          
          var sendsStatus = JSON.parse(JSON.stringify(this.sendsStatus))
          sendsStatus[s.id] = {status,message}
          this.sendsStatus = sendsStatus
          this.numberSent = this.numberSent +1
          this.percentageReady = Math.ceil((this.numberSent/this.totalForSend) * 100)
          await this.timer(1500);

        }
      },
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.sendProgressVisible = false
      },
      copyToClipboard (text) {
        const el = document.createElement('textarea');
        el.addEventListener('focusin', e => e.stopPropagation());
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/SendEmailsProgress.vue